(() => {
  const STORAGE_KEY = 'cosmeau-pip-hunt-v2';
  const SPOTS = [
    {
      id: 'geurparels',
      label: 'Geurige schat',
      invent: 'Pip snuffelde tussen de parels.',
      hint: 'Hint: waar frisse wasgeur begint. Zoek tussen geurparels, niet in het menu.',
      match: (path) => /\/products\/(geurparels-geurbooster-wasparfum|geurparels-geurbooster-wasparfum)\/?$/i.test(path),
      anchors: [
        '[data-cv6-pip-anchor="geurparels"]',
        '.gp-quality__panel',
        '#gp-quality-heading-' ,
        '.gp-quality'
      ],
      place: 'bottom-stick',
      requireText: 'Wat onze geurparels anders maakt'
    },
    {
      id: 'g6',
      label: 'Grote zes',
      invent: 'Pip hing achter de G6-kaart.',
      hint: 'Hint: onze nieuwste wasgeneratie. Kijk op de wasstrips-pagina bij een voordeel- of enzymkaart.',
      match: (path) => /\/products\/(wasmiddel-wasstrips-g6|wasmiddel-wasstrips-g6-joey)\/?$/i.test(path),
      anchors: [
        '[data-cv6-pip-anchor="g6"]',
        '.cv6-g6-enzymes .cv6-enzyme',
        '.cv6-g6-enzymes article',
        '.cv6-g6-benefits article',
        '.cv6-g6-story',
        'main .product__info-wrapper',
        'main .product',
        'main article'
      ],
      place: 'br'
    },
    {
      id: 'overons',
      label: 'Crewhoek',
      invent: 'Pip zat bij de mensen achter Cosmeau.',
      hint: 'Hint: leer wie Cosmeau is. Scroll op Over ons naar “De mensen die het waarmaken”.',
      match: (path) => /\/pages\/over-ons\/?$/i.test(path),
      anchors: [
        '[data-cv6-pip-anchor="overons"]',
        '.cv6-about-team',
        '.cv6-about-team__copy',
        '.cv6-about-person'
      ],
      place: 'br',
      requireText: 'De mensen die het waarmaken'
    },
    {
      id: 'productie',
      label: 'Fabrieksspoor',
      invent: 'Pip las mee in de productie-updates.',
      hint: 'Hint: kijk achter de schermen van maken en machines. Blader door de productie-updates.',
      match: (path) => /\/blogs\/productie(\/|$)/i.test(path),
      anchors: [
        '[data-cv6-pip-anchor="productie"]',
        '.blog-articles__article',
        '.article-card',
        'main .card',
        'main article'
      ],
      place: 'br'
    },
    {
      id: 'vlekkenwijzer',
      label: 'Vlekspoor',
      invent: 'Pip hing bij de vlekkengids.',
      hint: 'Hint: kies een vlek en krijg advies. Pip zit op een vlekkenkaart in de wijzer.',
      match: (path) => /\/pages\/vlekkenwijzer\/?$/i.test(path),
      anchors: [
        '[data-cv6-pip-anchor="vlekkenwijzer"]',
        '.cv6-vlekkenwijzer [data-stain]',
        '.cv6-vlekkenwijzer button',
        '.cv6-vlekkenwijzer article',
        '.cv6-vlekkenwijzer .card',
        'main article',
        'main button'
      ],
      place: 'br'
    },
    {
      id: 'schoonmaakwijzer',
      label: 'Schone tip',
      invent: 'Pip poetste stiekem mee in de schoonmaakwijzer.',
      hint: 'Hint: niet alleen wassen, ook poetsen. Open onze schoonmaakwijzer en kijk op een tipkaart.',
      match: (path) => /\/pages\/schoonmaakwijzer\/?$/i.test(path),
      anchors: [
        '[data-cv6-pip-anchor="schoonmaakwijzer"]',
        '.cv6-smw__job[data-cv6-pip-anchor="schoonmaakwijzer"]',
        '.cv6-smw__job',
        '.cv6-smw article',
        'main article'
      ],
      place: 'br'
    }
  ];
  const TOTAL = SPOTS.length;

  const pathOf = (url) => {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (_) {
      return '/';
    }
  };

  const barePath = (path) => path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '') || path;

  const localeRoot = () => {
    const parts = window.location.pathname.split('/').filter(Boolean);
    if (
      parts[0] &&
      /^[a-z]{2}(-[a-z]{2})?$/i.test(parts[0]) &&
      !['pages', 'collections', 'blogs', 'products', 'cart', 'account', 'search'].includes(parts[0].toLowerCase())
    ) {
      return '/' + parts[0].toLowerCase();
    }
    return '';
  };

  const withLocale = (href) => {
    if (!href || href.startsWith('http') || href.startsWith('#')) return href;
    const root = localeRoot();
    if (!root) return href;
    if (href === root || href.startsWith(root + '/')) return href;
    return root + (href.startsWith('/') ? href : '/' + href);
  };

  const readState = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { found: [], updatedAt: null };
      const data = JSON.parse(raw);
      const found = Array.isArray(data.found)
        ? data.found.filter((id) => SPOTS.some((s) => s.id === id))
        : [];
      return { found: [...new Set(found)], updatedAt: data.updatedAt || null };
    } catch (_) {
      return { found: [], updatedAt: null };
    }
  };

  const writeState = (state) => {
    const next = {
      found: [...new Set(state.found || [])],
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent('cv6:pip-hunt:update', { detail: next }));
    return next;
  };

  const currentSpot = () => {
    const path = pathOf(window.location.href);
    const bare = barePath(path);
    return SPOTS.find((spot) => spot.match(bare) || spot.match(path)) || null;
  };

  const assetMap = () => {
    const node = document.getElementById('cv6-pip-hunt-config');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (_) {
      return {};
    }
  };

  const toast = (message) => {
    let el = document.querySelector('[data-cv6-pip-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-cv6-pip-toast', '');
      el.className = 'cv6-pip-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-show');
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(() => el.classList.remove('is-show'), 2600);
  };

  const celebrate = (spot) => {
    const assets = assetMap();
    const overlay = document.createElement('div');
    overlay.className = 'cv6-pip-catch';
    overlay.innerHTML = `
      <div class="cv6-pip-catch__card" role="dialog" aria-modal="true" aria-label="Pip gevonden">
        <img src="${assets.stickers?.[spot.id] || assets.hero || ''}" alt="Pip sticker ${spot.label}" width="180" height="180">
        <h2>Pip gevangen!</h2>
        <p>${spot.invent}</p>
        <div class="cv6-pip-catch__actions">
          <a class="cv6-pip-catch__primary" href="${withLocale('/pages/pip-speurtocht')}">Naar je album</a>
          <button type="button" class="cv6-pip-catch__ghost" data-cv6-pip-catch-close>Verder snuffelen</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    const close = () => overlay.remove();
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay || e.target.closest('[data-cv6-pip-catch-close]')) close();
    });
    window.setTimeout(close, 8000);
  };

  const markFound = (spotId, { silent } = {}) => {
    const spot = SPOTS.find((s) => s.id === spotId);
    if (!spot) return readState();
    const state = readState();
    if (state.found.includes(spotId)) return state;
    state.found.push(spotId);
    const next = writeState(state);
    if (!silent) {
      toast(`Pip gevangen: ${spot.label} (${next.found.length}/${TOTAL})`);
      celebrate(spot);
    }
    return next;
  };

  const reset = () => writeState({ found: [] });

  const pickHost = (spot) => {
    const need = (spot.requireText || '').toLowerCase();
    for (const sel of spot.anchors || []) {
      let nodes = [];
      try {
        nodes = [...document.querySelectorAll(sel)];
      } catch (_) {
        continue;
      }
      nodes = nodes.filter((n) => {
        const r = n.getBoundingClientRect();
        if (r.width < 80 || r.height < 48) return false;
        if (!need) return true;
        const txt = (n.textContent || '').toLowerCase();
        return txt.includes(need);
      });
      if (!nodes.length) continue;
      // Prefer lower page content over first fold chrome.
      const preferred = nodes
        .slice()
        .sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)
        .find((n) => n.getBoundingClientRect().top > 180) || nodes[nodes.length - 1];
      return preferred;
    }
    // Final fallback by required text alone
    if (need) {
      const candidates = [...document.querySelectorAll('section, article, div')].filter((n) => {
        const r = n.getBoundingClientRect();
        if (r.width < 160 || r.height < 80) return false;
        const txt = (n.textContent || '').toLowerCase();
        return txt.includes(need) && txt.length < 4000;
      });
      if (candidates.length) return candidates[candidates.length - 1] || candidates[0];
    }
    return null;
  };

  const ensureHostReady = (host, spot) => {
    const style = window.getComputedStyle(host);
    if (style.position === 'static') host.classList.add('cv6-pip-host');
    // Let stickers stick out under cards; quality panels clip by default.
    if (style.overflow === 'hidden' || spot?.place === 'bottom-stick') host.classList.add('cv6-pip-host--open');
  };

  const mountPeek = () => {
    const spot = currentSpot();
    if (!spot) return;
    if (document.querySelector(`[data-cv6-pip-spot="${spot.id}"]`)) return;
    const state = readState();
    if (state.found.includes(spot.id)) return;

    const assets = assetMap();
    const src = assets.peeks?.[spot.id] || assets.stickers?.[spot.id] || assets.hero;
    if (!src) return;

    const host = pickHost(spot);
    if (!host) return;
    ensureHostReady(host, spot);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `cv6-pip-peek cv6-pip-peek--${spot.id} cv6-pip-peek--${spot.place || 'br'}`;
    btn.setAttribute('data-cv6-pip-spot', spot.id);
    btn.setAttribute('aria-label', `Pip gevonden: ${spot.label}`);
    btn.innerHTML = `<img src="${src}" alt="" width="120" height="120" decoding="async">`;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      markFound(spot.id);
      btn.classList.add('is-caught');
      window.setTimeout(() => btn.remove(), 420);
    });
    host.appendChild(btn);
  };

  const ensureStyles = () => {
    if (document.getElementById('cv6-pip-hunt-style')) return;
    const style = document.createElement('style');
    style.id = 'cv6-pip-hunt-style';
    style.textContent = `
      .cv6-pip-host{position:relative!important}
      .cv6-pip-host--open{overflow:visible!important}
      .cv6-pip-peek{position:absolute;z-index:6;width:78px;height:78px;padding:0;border:0;background:transparent;cursor:pointer;filter:drop-shadow(0 10px 14px rgba(60,45,90,.2));transition:transform .18s ease,opacity .18s ease}
      .cv6-pip-peek img{display:block;width:100%;height:100%;object-fit:contain;pointer-events:none}
      .cv6-pip-peek--br{right:6px;bottom:-6px}
      .cv6-pip-peek--schoonmaakwijzer{right:8px;bottom:-36px;width:84px;height:84px}
      .cv6-smw .cv6-pip-host,.cv6-smw .cv6-pip-host--open{overflow:visible!important}
      .cv6-pip-peek--bl{left:6px;bottom:-6px}
      .cv6-pip-peek--tr{right:8px;top:-10px}
      .cv6-pip-peek--bottom-stick{left:50%;right:auto;bottom:-22px;width:96px;height:96px;transform:translateX(-50%)}
      .cv6-pip-peek--bottom-stick:hover,.cv6-pip-peek--bottom-stick:focus-visible{transform:translateX(-50%) translateY(-3px) scale(1.05)}
      .cv6-pip-peek:hover,.cv6-pip-peek:focus-visible{transform:translateY(-3px) scale(1.05);outline:none}
      .cv6-pip-peek.is-caught{transform:scale(.55);opacity:0}
      .cv6-pip-toast{position:fixed;left:50%;bottom:28px;z-index:70;transform:translate(-50%,20px);padding:12px 16px;border-radius:999px;background:rgba(36,31,48,.92);color:#fff;font:700 13px/1.3 "Plus Jakarta Sans",system-ui,sans-serif;opacity:0;pointer-events:none;transition:opacity .2s ease,transform .2s ease}
      .cv6-pip-toast.is-show{opacity:1;transform:translate(-50%,0)}
      .cv6-pip-catch{position:fixed;inset:0;z-index:80;display:grid;place-items:center;padding:18px;background:rgba(40,30,60,.34);backdrop-filter:blur(8px)}
      .cv6-pip-catch__card{width:min(360px,100%);padding:22px 20px 18px;border:1px solid rgba(255,255,255,.8);border-radius:26px;background:rgba(255,255,255,.92);box-shadow:0 24px 60px rgba(74,54,110,.24);text-align:center;font-family:"Plus Jakarta Sans",system-ui,sans-serif;color:#241f30}
      .cv6-pip-catch__card img{width:150px;height:150px;object-fit:contain;margin:0 auto;filter:drop-shadow(0 12px 18px rgba(60,45,90,.18))}
      .cv6-pip-catch__card h2{margin:8px 0 0;font-size:24px;font-weight:900;letter-spacing:-.03em}
      .cv6-pip-catch__card p{margin:8px 0 0;color:#544e63;font-size:14.5px;font-weight:600;line-height:1.45}
      .cv6-pip-catch__actions{display:grid;gap:8px;margin-top:16px}
      .cv6-pip-catch__primary{display:inline-flex;justify-content:center;padding:12px 16px;border-radius:999px;background:linear-gradient(180deg,#57cf53,#42b93f);color:#fff!important;font-weight:800;text-decoration:none}
      .cv6-pip-catch__ghost{appearance:none;border:0;border-radius:999px;padding:11px 16px;background:#efeaf8;color:#4b4557;font:800 13px/1 "Plus Jakarta Sans",system-ui,sans-serif;cursor:pointer}
      @media (max-width:749px){
        .cv6-pip-peek{width:66px;height:66px}
        .cv6-pip-peek--br{right:2px;bottom:-4px}
        .cv6-pip-peek--schoonmaakwijzer{right:4px;bottom:-30px;width:68px;height:68px}
        .cv6-pip-peek--bottom-stick{bottom:-28px;width:84px;height:84px}
      }
      @media (prefers-reduced-motion:reduce){
        .cv6-pip-peek,.cv6-pip-toast{transition:none}
      }`;
    document.head.appendChild(style);
  };

  window.Cv6PipHunt = {
    SPOTS,
    TOTAL,
    readState,
    markFound,
    reset,
    withLocale,
    currentSpot,
    assetMap
  };

  const boot = () => {
    ensureStyles();
    // Wait a tick so section cards exist.
    window.requestAnimationFrame(() => mountPeek());
    window.setTimeout(mountPeek, 250);
    window.setTimeout(mountPeek, 900);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
